import React from 'react';
import PropTypes from 'prop-types';
import { VaAdditionalInfo } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import KeyValueTable from './KeyValueTable';

const POADetailsAuthorization = ({
  addressChange,
  recordDisclosureLimitations,
}) => {
  const Authorized = () => {
    return (
      <span>
        <va-icon
          size="3"
          icon="check_circle"
          class="vads-u-color--success-dark poa-request__card-icon"
        />
        Authorized
      </span>
    );
  };

  const NoAccess = () => {
    return (
      <span>
        <va-icon
          size="3"
          icon="warning"
          class="vads-u-color--warning-dark poa-request__card-icon"
          aria-hidden="true"
        />
        Not authorized
      </span>
    );
  };

  const checkAuthorizations = x => {
    if (x) {
      return <NoAccess />;
    }
    return <Authorized />;
  };
  const checkLimitations = (limitations, limit) => {
    const checkLimitation = limitations.includes(limit);
    return checkAuthorizations(checkLimitation);
  };

  const medicalRecordsData = {
    'Alcoholism or alcohol abuse records': checkLimitations(
      recordDisclosureLimitations,
      'ALCOHOLISM',
    ),
    'Drug abuse records': checkLimitations(
      recordDisclosureLimitations,
      'DRUG_ABUSE',
    ),
    'HIV records': checkLimitations(recordDisclosureLimitations, 'HIV'),
    'Sickle cell anemia records': checkLimitations(
      recordDisclosureLimitations,
      'SICKLE_CELL',
    ),
  };

  const claimantAddressData = {
    'Change of address': addressChange ? <Authorized /> : <NoAccess />,
  };

  return (
    <>
      <h2 className="poa-request-details__h2 is--authorization-h2">
        Authorization information
      </h2>

      {recordDisclosureLimitations.length > 0 ? (
        <VaAdditionalInfo
          trigger="You won’t have access to the claimant’s eFolder in VBMS"
          uswds
        >
          <p>
            The claimant didn’t authorize access to all medical records. If you
            accept this request, representation will be established but you
            won’t have access to the claimant’s eFolder in the Veterans Benefits
            Management System (VBMS).
          </p>
        </VaAdditionalInfo>
      ) : (
        <VaAdditionalInfo
          trigger="You will have access to the claimant’s eFolder in VBMS"
          uswds
        >
          <p>
            The claimant authorized access to all medical records. If you accept
            this request, representation will be established and you’ll have
            access to the claimant’s eFolder in the Veterans Benefits Management
            System (VBMS).
          </p>
        </VaAdditionalInfo>
      )}

      <h3
        className="poa-request-details__h3 is--authorization-h3"
        id="medical-records-heading"
      >
        Protected medical records access
      </h3>
      <KeyValueTable
        headingId="medical-records-heading"
        data={medicalRecordsData}
      />
      <h3
        className="poa-request-details__h3 is--authorization-h3"
        id="claimant-address-heading"
      >
        Claimant address
      </h3>
      <KeyValueTable
        headingId="claimant-address-heading"
        data={claimantAddressData}
      />
    </>
  );
};

POADetailsAuthorization.propTypes = {
  addressChange: PropTypes.bool,
  recordDisclosureLimitations: PropTypes.array,
};

export default POADetailsAuthorization;
